import { useEffect, useState } from 'react'
import { useRouteOnMapStoreActions, useRouteOnMapStoreState } from '../../../stores/MapLayers/RouteOnMapStore';

export function RouteOnMapLayer() {
    const [className, setClassName] = useState('mapLayerContainerInactive');

    const open = useRouteOnMapStoreState();
    const { toggleOpen } = useRouteOnMapStoreActions();

    useEffect(() => {
        if(open){
            setClassName('mapLayerContainerActive')
        }
        else{
            setClassName('mapLayerContainerInactive')
        }
    }, [open])

    return(
        <div style={{display: 'grid', marginLeft: '20px', maxHeight: '90%'}}>
            <div className={className} onClick={toggleOpen}>
                <div style={{width: '28px', height: '6vh', margin: 'auto'}}/>
            </div>
            <p style={{fontSize: '14px', margin: 'auto', fontWeight: 'bold'}}>Rute</p>
        </div>
    )
}